import React, { useState } from 'react';

const UnitDetailsPlans = ({ plans }) => {
    const [selectedPlan, setSelectedPlan] = useState('Flexible plan');
    console.log("plans", plans)
    const handlePlanClick = (planTitle) => {
        setSelectedPlan(planTitle);
    };

    const selectedPlanData = plans && plans.find(plan => plan.title.toLowerCase() === selectedPlan.toLowerCase());

    return (
        <div id="seePricing" className='unit-details-plans-bg-clr'>
            <div className='container'>
                <div className='unit-details-plans-main-div'>
                    <div className='header-text-buttons-main-div'>
                        <div className='header-text'>
                            <h4>Price Plans</h4>
                        </div>
                        <div className='button-div-main'>
                            {['Flexible plan', 'discount plan', 'investor plan', 'Elite plan'].map((plan) => (
                                <button
                                    key={plan}
                                    onClick={() => handlePlanClick(plan)}
                                    className={selectedPlan === plan ? 'selected-plan' : ''}
                                >
                                    {plan}
                                </button>
                            ))}
                        </div>
                    </div>

                    {selectedPlanData && (
                        <div className='body-text-table-main-div'>
                            <div className='body-text-div'>
                                <div className='body-text-h2'>
                                    <h2>{selectedPlanData.title}</h2>
                                </div>
                                {/* <div className='body-text-h5'>
                                    <h5><span>{selectedPlanData.description}</span></h5>
                                </div> */}
                                <div className='body-text-h4'>
                                    <h4>Price AED {Math.floor(selectedPlanData.price).toLocaleString()}</h4>
                                </div>
                                <div className='body-text-h5'>
                                    <h5>Down Payment <span>{selectedPlanData.downPaymentPercentage}%</span></h5>
                                </div>
                                <div className='body-text-h5'>
                                    <h5><span>+{selectedPlanData.dldRegistrationPercentage}%</span> Dubai land department registration charges</h5>
                                </div>
                                <div className='body-text-h5'>
                                    <h5>+DLD approved admin fee <span> AED {selectedPlanData.dldCertifiedAdminCharges}</span></h5>
                                </div>
                            </div>

                            <div className="table-container">
                                <table className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Installment %</th>
                                            <th>Installment amount in AED</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Always show these rows */}
                                        <tr>
                                            <td>Down Payment</td>
                                            <td>{selectedPlanData.downPaymentPercentage}%</td>
                                            <td>{Math.floor(selectedPlanData.downPayment).toLocaleString()}</td>
                                        </tr>
                                        <tr>
                                            <td>DLD Registration Charges</td>
                                            <td>{selectedPlanData.dldRegistrationPercentage}%</td>
                                            <td>{Math.floor(selectedPlanData.dldUnitRegistrationChargesAtTimeOfDownPayment).toLocaleString()}</td>
                                        </tr>
                                        <tr>
                                            <td>DLD Certified Admin Charges</td>
                                            <td>{selectedPlanData.dldCertifiedAdminCharges} AED</td>
                                            <td>{Math.floor(selectedPlanData.dldCertifiedAdminCharges).toLocaleString()}</td>
                                        </tr>
                                        <tr className="highlighted">
                                            <td>Total Down Payment</td>
                                            <td></td>
                                            <td>{Math.floor(selectedPlanData.totalDownPayment).toLocaleString()}</td>
                                        </tr>

                                        {/* Conditionally show or hide rows based on selected plan */}
                                        {['Flexible plan'].includes(selectedPlan) && (
                                            <>
                                                <tr>
                                                    <td>60 Days From Booking</td>
                                                    <td>{selectedPlanData.plan['60DaysFromBookingPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['60DaysFromBooking']).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>120 Days From Booking</td>
                                                    <td>{selectedPlanData.plan['120DaysFromBookingPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['120DaysFromBooking']).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>180 Days From Booking</td>
                                                    <td>{selectedPlanData.plan['180DaysFromBookingPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['180DaysFromBooking']).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>Upon 35% Completion</td>
                                                    <td>{selectedPlanData.plan['upon35PercentCompletionPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['upon35PercentCompletion']).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>Upon 45% Completion</td>
                                                    <td>{selectedPlanData.plan['upon45PercentCompletionPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['upon45PercentCompletion']).toLocaleString()}</td>
                                                </tr>
                                            </>
                                        )}
                                        {['discount plan'].includes(selectedPlan) && (
                                            <>
                                                <tr>
                                                    <td>Upon 20% Completion</td>
                                                    <td>{selectedPlanData.plan['upon20PercentCompletionPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['upon20PercentCompletion']).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>Upon 35% Completion</td>
                                                    <td>{selectedPlanData.plan['upon35PercentCompletionPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['upon35PercentCompletion']).toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td>Upon 45% Completion</td>
                                                    <td>{selectedPlanData.plan['upon45PercentCompletionPercentage']}%</td>
                                                    <td>{Math.floor(selectedPlanData.plan['upon45PercentCompletion']).toLocaleString()}</td>
                                                </tr>
                                            </>
                                        )}
                                        {/* Conditionally show 'Upon 100% Completion' for all except 'Elite plan' */}
                                        {selectedPlan !== 'Elite plan' && (
                                            <tr>
                                                <td>Upon 100% Completion</td>
                                                <td>{selectedPlanData.plan['upon100PercentCompletionPercentage']}%</td>
                                                <td>{Math.floor(selectedPlanData.plan['upon100PercentCompletion']).toLocaleString()}</td>
                                            </tr>
                                        )}

                                        {/* Total Row */}
                                        <tr className="total">
                                            <td>Total</td>
                                            <td></td>
                                            <td>{Math.floor(selectedPlanData.plan.total).toLocaleString()}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UnitDetailsPlans;
